import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { RelationActionButton } from '@/components/common/RelationActionButton';
import { useFormik } from 'formik';
import { z } from 'zod';
import { toFormikValidate } from 'zod-formik-adapter';

const addNewSubscriptionSchema = z.object({
  name: z.string().min(1, 'Subscription name must contain at least one letter'),
});

type AddNewSubscriptionValues = z.infer<typeof addNewSubscriptionSchema>;

interface AddNewSubscriptionProps {
  onSubmit: (name: string) => void;
  onCancel: () => void;
  isPending?: boolean;
}

export function AddNewSubscription({
  onSubmit,
  onCancel,
  isPending,
}: AddNewSubscriptionProps) {
  const formik = useFormik<AddNewSubscriptionValues>({
    initialValues: {
      name: '',
    },
    validate: toFormikValidate(addNewSubscriptionSchema),
    onSubmit: (values) => {
      onSubmit(values.name);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="mt-4 flex flex-col gap-4">
      <Input
        id="name"
        name="name"
        label="Subscription Name"
        placeholder="Enter subscription name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.name}
        touched={formik.touched.name}
      />
      <div className="flex items-center justify-between gap-4">
        <Button type="submit" variant="primary" size="md" disabled={isPending}>
          {isPending ? 'Processing...' : 'Continue'}
        </Button>
        <RelationActionButton type="button" onClick={onCancel}>
          Cancel
        </RelationActionButton>
      </div>
    </form>
  );
}
